import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { amenitiesActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of } from 'rxjs';
import { AmenitiesService } from '../../services/amenities.service';

@Injectable({
  providedIn: 'root',
})
export class AmenitiesEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private amenitiesService: AmenitiesService,
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(amenitiesActions.findAll),
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        return this.amenitiesService.findAll().pipe(
          map((response) =>
            amenitiesActions.findAllSuccess({
              amenities: response.data,
              total: response.total,
            }),
          ),
          catchError((error: ApiError) =>
            of(amenitiesActions.findError({ error: error.message })),
          ),
        );
      }),
    ),
  );
}
